import React, { useState, useContext, useEffect } from 'react';
import { Row, Col, Card, Switch, Alert } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Context } from '../../../../../defaults';
import { ViewDocument } from '../../../../../components';

const Question2 = ({ data, setData, current }) => {
    const { dictionary, language } = useContext(Context);

    const onChange = (checked) => {
        setData({ ...data, studentAnswer: { ...data.studentAnswer, isRight: checked ? 1 : 0 } });
    }

    return (
        <div>
            <div key={`answer1${data.question}`} style={{ marginTop: 20 }}>
                <Row gutter={16}>
                    <Col span={20}>
                        {
                            data.studentAnswer.answerVariants && data.studentAnswer.answerVariants.length > 0 &&
                            data.studentAnswer.answerVariants[0].files &&
                            <ViewDocument files={data.studentAnswer.answerVariants[0].files} />
                        }
                        {
                            data.studentAnswer.answerVariants && data.studentAnswer.answerVariants.length > 0 &&
                            data.studentAnswer.answerVariants[0].answerHtml &&
                            <Row gutter={16} style={{ marginBottom: 50 }}>
                                <Col span={24}>
                                    <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: data.studentAnswer.answerVariants[0].answerHtml }} />
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
                <div style={{ marginTop: 30 }}>
                    <Alert message={`${dictionary?.Score[language]}: ${data.studentAnswer.point}/${data.question.point}`} type={data.studentAnswer?.point > 0 ? 'success' : 'error'} showIcon />
                </div>

                {
                    data.studentAnswer.usedHint === 1 &&
                    <div style={{ marginTop: 30 }}>
                        <Alert message={dictionary?.HintUsed[language]} type={'warning'} showIcon />
                    </div>
                }
            </div>
        </div>
    );
}

export default Question2;